import { registerLocaleData } from '@angular/common';
import {
  enableProdMode,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  BrowserModule,
  bootstrapApplication
} from '@angular/platform-browser';

import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import localeHu from '@angular/common/locales/hu';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { providePayeeDialog } from 'src/app/shared/dialog/provide-payee-dialog';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { RedirectGuard } from './app/services/redirect/redirect.guard';
import { environment } from './environments/environment';

registerLocaleData(localeHu, 'hu');

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    ...providePayeeDialog(),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: TranslateHttpLoader,
          deps: [HttpClient],
        },
        extend: true,
      }),
      BrowserModule,
      AppRoutingModule,
    ),
    RedirectGuard,
    provideHttpClient(withInterceptorsFromDi()),
  ],
}).catch((err: unknown) => console.error(err));
